export const COMMUNITY_BOARDS = {
  matching: {
    label: '우리 동네 피클 볼러',
    description: '같이 플레이할 파트너를 찾는 매칭 게시판입니다.',
  },
  free: {
    label: '자유게시판',
    description: '자유롭게 소식을 나누는 커뮤니티 공간입니다.',
  },
};

export const resolveBoardConfig = (key) => COMMUNITY_BOARDS[key] || COMMUNITY_BOARDS.matching;
